import { SLUG_TOO_SHORT_MESSAGE } from '../lib/workspaceSlug';
import { cls } from '../components/formStyles';

/**
 * The field-level error for a web address under 2 characters (crossmarc/steward-app#2050).
 * Rendered directly under the specific slug input that is short, because the founder forms each
 * have two fields with the same label. The input points at it with `aria-describedby` and
 * `aria-invalid`, the wiring `intake/fields.tsx` uses, with the same `cls.error` styling.
 */
export function SlugShortNote({ id }: { id: string }) {
  return <p id={id} className={cls.error}>{SLUG_TOO_SHORT_MESSAGE}</p>;
}
